var $ = require('jquery');

var MatchHeight= require('../functions/match-height');
var OverviewMap = require('../functions/overview-map');
var LocationMap = require('../functions/location-map');
var Sliders = require('../functions/sliders');
var Print = require('../functions/print');
var PageSlide = require('../functions/page-slide');
var Property = require('../functions/property');
var Calendars = require('../functions/calendars');
var Booking = require('../functions/booking');
var BackTop = require('../functions/back-top');

var attachFastClick = require('fastclick');

var jdMenu = require('../vendors/jd-menu/jd-menu');

$(document).ready(function() {
	attachFastClick(document.body);
	
	new MatchHeight();
	new Sliders();
	new Print();
	new PageSlide();
	new Property();
	new Calendars();
	new Booking();
	new BackTop();

	$(".js-mobile-menu").jdMenu({
		'trigger': $(".mobile-menu")
	});
});

window.initMap = function() {
	new OverviewMap();
	new LocationMap();
};